import { Box, Button, Typography } from "@material-ui/core";
import { CaretLeft, Export, Share } from "phosphor-react";
import { useHistory } from "react-router-dom";
import sequencerHeaderStyles from "./SequencerHeader.styles";

const SequencerHeader = ({
  projectId,
  sequencerName,
  viewMode,
  onViewModeChange,
  onExportClick,
  isExporting = false,
  exportDisabled = false,
  selectedVersion,
}) => {
  const classes = sequencerHeaderStyles();
  const history = useHistory();

  const displayName = sequencerName
    ? sequencerName.charAt(0).toUpperCase() + sequencerName.slice(1)
    : "";

  return (
    <Box className={classes.viewHeaderRoot}>
      <Box>
        <Typography className={classes.viewHeaderTitle}>{displayName}</Typography>
        {viewMode === "player" && <span style={{ fontSize: "12px", color: "#999" }}>{selectedVersion?.shotVersion?.name}</span>}
      </Box>
      <Box className={classes.viewHeaderRight}>
        <Button
          startIcon={<CaretLeft size={18} />}
          className={classes.viewHeaderBackButton}
          onClick={() => history.push(`/${projectId}/playlist`)}
        >
          Back to Playlists
        </Button>
        <Box className={classes.viewToggleGroup}>
          <Button
            className={
              viewMode === "player"
                ? classes.viewToggleActive
                : classes.viewToggleInactive
            }
            onClick={() => onViewModeChange("player")}
          >
            Player View
          </Button>
          <Button
            className={
              viewMode === "data"
                ? classes.viewToggleActive
                : classes.viewToggleInactive
            }
            onClick={() => onViewModeChange("data")}
          >
            Data View
          </Button>
        </Box>
        <Button
          disabled
          variant="outlined"
          startIcon={<Share size={18} />}
          className={classes.shareButton}
        >
          Share
        </Button>
        <Button
          disabled={exportDisabled || isExporting}
          onClick={onExportClick}
          variant="contained"
          className={classes.exportButton}
          startIcon={<Export size={18} />}
        >
          Export
        </Button>
      </Box>
    </Box>
  );
};

export default SequencerHeader;
